<div class="SearchBar SearchBar--show" [class.SearchBar--mobile]="isMobile"> 
    <input type="search" name="query" data-cy="searchBar" (keyup)="searchDocuments($event.target.value)" (keyup.enter)="searchDocuments($event.target.value)" placeholder="Search...">
</div>
